import React from "react";

export default function FoundingTermsModal({ accepted, setAccepted, onClose }) {
    return (
        <div
            className="fixed inset-0 bg-black/50 z-[70] flex items-end sm:items-center justify-center px-3 pb-3 sm:p-6"
            onClick={onClose}
            data-testid="terms-modal"
        >
            <div
                onClick={e => e.stopPropagation()}
                className="w-full sm:max-w-md bg-cream border border-burgundy/20 max-h-[85vh] flex flex-col"
            >
                <div className="px-6 pt-6 pb-3 border-b border-burgundy/15">
                    <div className="text-[10px] tracking-[0.32em] uppercase text-gold-deep">Pre-purchase</div>
                    <h3 className="mt-1 font-display text-2xl text-burgundy">
                        <span className="italic">Founding</span> Member Terms
                    </h3>
                </div>
                <div className="flex-1 overflow-y-auto px-6 py-4 text-sm leading-relaxed text-ink space-y-3">
                    <p>By purchasing Ever After Founding Membership for $99, you agree to the following:</p>
                    <ul className="list-disc pl-5 space-y-2">
                        <li>You will receive immediate access to your full compatibility assessment, archetype reveal, and all currently available beta features.</li>
                        <li>Your $99 founding fee will be applied as a $99 credit toward any subscription tier you select when Ever After officially launches.</li>
                        <li>Your $99 credit does not expire and will be honored at launch regardless of when launch occurs.</li>
                        <li>Your founding access during the beta period does not auto-renew and will not result in additional charges.</li>
                        <li>You may request a full refund within 30 days of purchase for any reason by emailing{" "}
                            <a href="mailto:info@youreverafter.com" className="underline text-burgundy">info@youreverafter.com</a>.
                        </li>
                        <li>Founding Membership status is non-transferable.</li>
                        <li>Ever After reserves the right to modify features, pricing, and product offerings during the beta period. Your $99 credit remains honored regardless of changes.</li>
                    </ul>
                </div>
                <div className="px-6 py-4 border-t border-burgundy/15 space-y-2">
                    <label className="flex items-start gap-2 cursor-pointer">
                        <input
                            data-testid="terms-modal-checkbox"
                            type="checkbox"
                            checked={accepted}
                            onChange={e => setAccepted(e.target.checked)}
                            className="mt-1 w-4 h-4 accent-burgundy"
                        />
                        <span className="text-xs leading-snug text-ink">
                            I understand and agree to the Founding Member Terms above.
                        </span>
                    </label>
                    <button
                        data-testid="terms-modal-close"
                        onClick={onClose}
                        className="w-full bg-burgundy text-cream uppercase text-[11px] tracking-[0.22em] py-3 hover:bg-burgundy-deep transition-colors disabled:opacity-50"
                        disabled={!accepted}
                    >
                        {accepted ? "Continue" : "Check the box to continue"}
                    </button>
                </div>
            </div>
        </div>
    );
}
